export const TABLE_PAGE_SIZE = 10;
export const SIZE_MEDIUM = 'medium';
export const KEY_LEAD_SOURCE_NAME = 'name';
export const CREATE_LEAD_SOURCE_BUTTON_NAME = 'CREATE';
export const LEAD_SOURCE_DROP_DOWN_NAME = 'lead source';
export const LEAD_SOURCE_CLEAR_BUTTON_NAME = 'clear lead source';

export const TABLE_COLUMNS = [
  { key: KEY_LEAD_SOURCE_NAME, title: 'Lead source', variant: 'text', size: SIZE_MEDIUM, sortable: true },
];

export const SEARCH_DEBOUNCE_TIME = 500;
export const RESOURCE_TYPE_CUSTOMER = 'customer_uuid';
export const RESOURCE_TYPE_JOB = 'job_uuid';
export const RESOURCE_TYPE_ESTIMATE = 'estimate_uuid';
export const RESOURCE_TYPE_BETA_ESTIMATES = 'beta_estimate_uuids';
export const RESOURCE_TYPE_JOBS = 'job_uuids';
